const InfiniteScroll = require("infinite-scroll");

document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector("#filter-form");
  const loadMoreButton = document.getElementById(
    "infiniteScrollLoadingStatusLoadMore"
  );

  // Handle location form submission
  document.addEventListener("locationFormSubmit", (e) => {
    form.setAttribute(
      "action",
      e.detail.location === "" ? window.location : e.detail.geoItem.url
    );
    form
      .querySelector("input[name=adults]")
      .setAttribute("value", e.detail.adults);
    form.querySelector("input[name=kids]").setAttribute("value", e.detail.kids);
    form.querySelector("input[name=dogs]").setAttribute("value", e.detail.dogs);
    form
      .querySelector("input[name=bookingFrom]")
      .setAttribute("value", e.detail.bookingFrom);
    form
      .querySelector("input[name=bookingTo]")
      .setAttribute("value", e.detail.bookingTo);

    form.submit();
  });

  // Reset all filters to initial values
  form.addEventListener("reset", (e) => {
    e.preventDefault();

    form.querySelectorAll("input:checked").forEach((i) => (i.checked = false));
    form
      .querySelectorAll(".quantitystepper input")
      .forEach((i) => (i.value = i.getAttribute("min")));
    form.querySelector("#maxPrice").value = form
      .querySelector("#maxPrice")
      .getAttribute("max");

    submitForm();
  });

  // Sync sort buttons
  const searchSortMobile = document.querySelector("#searchSortMobile");
  if (searchSortMobile) {
    searchSortMobile.addEventListener("change", (e) => {
      const label = document.querySelector("#currentSortLabelMobile");
      if (label && e.target.selectedOptions && e.target.selectedOptions.length) {
        label.textContent = e.target.selectedOptions[0].text.trim();
      }
      const desktopSort = document.querySelector("#searchSort");
      if (desktopSort) {
        desktopSort.value = searchSortMobile.value;
      }
      form.submit();
    });
  }

  // Sync price range inputs
  const range = document.getElementById("maxPriceRange");
  const number = document.getElementById("maxPrice");
  if (range && number) {
    range.addEventListener("input", function () {
      number.value = this.value;
    });
    number.addEventListener("input", function () {
      range.value = this.value;
    });
  }

  // Fetch Data
  document
    .querySelectorAll(
      "#searchSort, #searchDistance, #filter-form input,#fenceHeight"
    )
    .forEach((e) =>
      e.addEventListener("change", () => {
        submitForm();
      })
    );

  async function submitForm() {
    const formData = new FormData(form);
    let url = form.action;

    const params = new URLSearchParams(formData);
    url += "?" + params.toString();

    // Show loading indicator
    document.querySelector("#loadingStatus").classList.remove("hidden");
    document.querySelector("#listView").classList.add("hidden");
    document.querySelector("#toplistingView").classList.add("hidden");

    const response = await fetch(url, {
      method: form.method,
    });

    // replace newly fetched data
    const html = await response.text();
    const resultDoc = new DOMParser().parseFromString(html, "text/html");

    // Replace the old HTML-List structure with the newly fetched data
    document.querySelector("#listView").innerHTML =
      resultDoc.querySelector("#listView").innerHTML;
    document.querySelector("#toplistingView").innerHTML =
      resultDoc.querySelector("#toplistingView").innerHTML;
    document
      .querySelector("#map-data")
      .setAttribute(
        "data-items",
        resultDoc.querySelector("#map-data").getAttribute("data-items")
      );

    // Replace the old HTML-Results-Counter with the new count
    document.querySelector("#locationhero-smalltitle").innerHTML =
      resultDoc.querySelector("#locationhero-smalltitle").innerHTML;
    document
      .querySelectorAll(".headerresultcounter")
      .forEach((target, index) => {
        const source = resultDoc.querySelectorAll(".headerresultcounter")[
          index
        ];
        if (source) {
          target.innerHTML = source.innerHTML;
        }
      });

    // Replace the max page count
    document
      .querySelector("#listView")
      .setAttribute(
        "data-max-page",
        resultDoc.querySelector("#listView").getAttribute("data-max-page")
      );

    if (document.querySelector("#listView").getAttribute("data-max-page") > 1) {
      loadMoreButton.classList.remove("hidden");
    } else {
      loadMoreButton.classList.add("hidden");
    }

    // Replace title attribute
    document.querySelector("title").textContent =
      resultDoc.querySelector("title").textContent;

    // Render bookmark buttons
    window.bindBookmarkActions();

    // Bind sliders
    window.bindTnsSliders();

    // Bind modals
    window.initFlowbite();

    // Hide loading indicator
    document.querySelector("#loadingStatus").classList.add("hidden");
    document.querySelector("#listView").classList.remove("hidden");
    document.querySelector("#toplistingView").classList.remove("hidden");

    // Scroll to top of the list view
    const scrollTarget = document.querySelector(
      window.innerWidth < 1024 ? "#toplistingView" : "#listings"
    );

    if (scrollTarget) {
      const y =
        scrollTarget.getBoundingClientRect().top + window.pageYOffset - 124;
      window.scrollTo({ top: y, behavior: "smooth" });
    }

    buildInfiniteScroller(url);
  }

  // bind reset additional buttons
  document
    .querySelectorAll(".searchFormReset")
    .forEach((el) =>
      el.addEventListener("click", () =>
        document.querySelector("#filter-reset-btn").click()
      )
    );

  buildInfiniteScroller(location.href);

  function buildInfiniteScroller(url) {
    let currentPage = 1;

    if (window.scrollerInstance) {
      window.scrollerInstance.destroy();
      window.scrollerInstance = null;
    }

    if (!loadMoreButton) {
      return;
    }

    window.scrollerInstance = new InfiniteScroll(".infinitescroll", {
      path: ((u) => (
        u.searchParams.set("page", "{{#}}"),
        u.toString().replace("%7B%7B%23%7D%7D", "{{#}}")
      ))(new URL(url)),
      append: "#listView .listingcard, #listView .extended-headline",
      history: false,
      hideNav: ".pagination",
      scrollThreshold: false,
      onInit: function () {
        const maxPage = loadMoreButton.dataset.maxPage;

        this.on("load", () => {
          currentPage++;

          if (currentPage >= maxPage) {
            loadMoreButton.classList.add("hidden");
          }
        });

        this.on("append", () => {
          window.bindBookmarkActions();

          // Bind modals
          window.initFlowbite();

          loadMoreButton.removeAttribute("disabled");
        });
      },
    });
  }

  loadMoreButton.addEventListener("click", function () {
    loadMoreButton.setAttribute("disabled", "disabled");
    window.scrollerInstance.loadNextPage();
  });

  initFilterbarScrollIndicator();

  function initFilterbarScrollIndicator() {
    const indicator = document.getElementById("filterbar-scroll-indicator");
    const indicatorBtn = document.getElementById(
      "filterbar-scroll-indicator-btn"
    );

    if (!indicator) {
      return;
    }

    const getActiveScrollArea = () => {
      if (window.innerWidth >= 1024) {
        return document.querySelector(".filterbar-desktop-scroll-area");
      }
      return (
        document.querySelector(".filterbar-mobile-scroll-area") ||
        indicator.closest(".overflow-y-auto")
      );
    };

    const hideIndicator = () => {
      indicator.classList.remove("opacity-100");
      indicator.classList.add("opacity-0", "pointer-events-none");
    };

    const showIndicator = () => {
      indicator.classList.remove("opacity-0", "pointer-events-none");
      indicator.classList.add("opacity-100");
    };

    const isResetButtonVisible = (scrollArea) => {
      if (window.innerWidth < 1024) {
        return (
          scrollArea.scrollTop + scrollArea.clientHeight >=
          scrollArea.scrollHeight - 30
        );
      }

      const resetBtn =
        document.querySelector('[slot="footer"] #filter-reset-btn') ||
        document.querySelector('[slot="footer"]');
      if (!resetBtn || !scrollArea) {
        return (
          scrollArea.scrollTop + scrollArea.clientHeight >=
          scrollArea.scrollHeight - 30
        );
      }

      const resetRect = resetBtn.getBoundingClientRect();
      const scrollRect = scrollArea.getBoundingClientRect();

      return (
        resetRect.top < scrollRect.bottom && resetRect.bottom > scrollRect.top
      );
    };

    const updateIndicator = () => {
      const scrollArea = getActiveScrollArea();
      if (!scrollArea) {
        hideIndicator();
        return;
      }

      const hasOverflow =
        scrollArea.scrollHeight > scrollArea.clientHeight + 20;

      if (hasOverflow && !isResetButtonVisible(scrollArea)) {
        showIndicator();
      } else {
        hideIndicator();
      }
    };

    document
      .querySelectorAll(
        ".filterbar-scroll-area, .filterbar-desktop-scroll-area, .filterbar-mobile-scroll-area"
      )
      .forEach((scrollArea) => {
        scrollArea.addEventListener(
          "scroll",
          () => {
            updateIndicator();
          },
          { passive: true }
        );
      });

    if (indicatorBtn) {
      indicatorBtn.addEventListener("click", (e) => {
        e.preventDefault();
        const scrollArea = getActiveScrollArea();
        if (scrollArea) {
          scrollArea.scrollBy({ top: 280, behavior: "smooth" });
        }
      });
    }

    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(() => {
        updateIndicator();
      });
      document
        .querySelectorAll(
          ".filterbar-scroll-area, .filterbar-desktop-scroll-area, .filterbar-mobile-scroll-area"
        )
        .forEach((scrollArea) => {
          resizeObserver.observe(scrollArea);
        });
      if (form) {
        resizeObserver.observe(form);
      }
    } else {
      window.addEventListener("resize", updateIndicator, { passive: true });
    }

    document.querySelectorAll("[data-showmore-toggle]").forEach((toggleBtn) => {
      toggleBtn.addEventListener("click", () => {
        setTimeout(updateIndicator, 150);
      });
    });

    window.addEventListener("resize", updateIndicator, { passive: true });

    requestAnimationFrame(() => {
      updateIndicator();
    });
  }
});
